import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { ContentRouteUtil } from '@utils/routeUtil';

const useRedirectAfterLogin = (redirectUrl?: string) => {
  const router = useRouter();
  const { data: userData, isLoading } = useUserInfo();
  const isLogin = !!userData?.id;

  useEffect(() => {
    if (isLoading) return;
    //isLoading이 없으면 useUserINnfo호출 전에 if문 실행됨.
    if (!isLogin && !redirectUrl) {
      return ContentRouteUtil.goLoginPage(router.asPath);
    }
    if (!isLogin && redirectUrl) ContentRouteUtil.goLoginPage(redirectUrl);
  }, [isLogin, isLoading]);
};

export default useRedirectAfterLogin;
